<template>
    <div class="applyRadioPage">
        <div class="bgFFFFFF areaTitle" v-if="showType && (isApproveData.openStatus === 3)">
            <span class="col666 f28">余额支付</span>
        </div>
        <div class="content mbot20" v-if="showBalance && payShow">
            <van-checkbox-group v-model="result" icon-size="20px" checked-color="#FF7A45">
                <van-cell-group>
                    <van-cell :clickable="true" v-if="!showType && isActivityShow" @click="toggle('activity')">
                        <div class="radioLeft">
                            <img :src="activityBalance.imgUrl" class="img">
                            <div class="name">
                                <p>
                                    <span class="text">{{activityBalance.text}}</span>
                                    <span class="tip col999">(余额：￥{{activityBalance.tip | NumFormat }})</span>
                                </p>
                                <p v-if="result.length > 1 || (payActivity && payActivity !== finalTotalAmount)">
                                    <span class="tip col999">(需要组合支付)</span>
                                    <span class="price">-￥{{ payActivity | NumFormat }}</span>
                                </p>
                            </div>
                        </div>
                         <template #right-icon>
                            <van-checkbox :disabled="(activityBalance.tip <= 0) || inRansom || balanceShow" :name="activityBalance.value" ref="checkboxes" />
                        </template>
                    </van-cell>
                    <van-cell :clickable="true" v-if="isApproveData.openStatus === 3" @click="toggle('wallet')">
                        <div class="radioLeft">
                            <img :src="walletBalance.imgUrl" class="img">
                            <div class="name">
                                <p>
                                    <span class="text">{{walletBalance.text}}</span>
                                    <span class="tip col999">(余额：￥{{walletBalance.tip | NumFormat }})</span>
                                </p>
                                <p  v-if="result.length > 1 || (payBalance && payBalance !== finalTotalAmount)">
                                    <span class="tip col999">(需要组合支付)</span>
                                    <span class="price">-￥{{payBalance | NumFormat }}</span>
                                </p>
                            </div>
                        </div>
                         <template #right-icon>
                            <van-checkbox :disabled="((isApproveData.openStatus === 3) && (walletBalance.tip <= 0)) || (activityShow)" :name="walletBalance.value" ref="checkboxesArr" />
                        </template>
                    </van-cell>
                </van-cell-group>
            </van-checkbox-group>
        </div>
        <div class="content mbot20" v-if="showBalance && !payShow">
            <van-radio-group v-model="radio" icon-size="20px" checked-color="#FF7A45">
                <van-cell-group>
                    <van-cell :clickable="true" @click="clickCell(activityBalance)" v-if="!showType && isActivityShow">
                        <div class="radioLeft">
                            <img :src="activityBalance.imgUrl" class="img">
                            <span class="text">{{activityBalance.text}}</span>
                            <span class="tip col999">(余额：￥{{activityBalance.tip | NumFormat }})</span>
                        </div>
                        <van-radio slot="right-icon" :disabled="activityBalance.tip <= 0 || inRansom" :name="activityBalance.value" />
                    </van-cell>
                    <van-cell :clickable="true" @click="clickCell(walletBalance)" v-if="isApproveData.openStatus === 3">
                        <div class="radioLeft">
                            <img :src="walletBalance.imgUrl" class="img">
                            <span class="text">{{walletBalance.text}}</span>
                            <span class="tip col999">(余额：￥{{walletBalance.tip | NumFormat }})</span>
                        </div>
                        <van-radio slot="right-icon" :disabled="(isApproveData.openStatus !== 3) && (walletBalance.tip <= 0)" :name="walletBalance.value" />
                    </van-cell>
                </van-cell-group>
            </van-radio-group>
        </div>
        <div class="bgFFFFFF areaTitle">
            <span class="col666 f28">第三方支付</span>
        </div>
        <div class="content mbot20">
            <van-radio-group v-model="radio" icon-size="20px" checked-color="#FF7A45">
                <van-cell-group>
                    <van-cell v-for="(item, index) in paymentList" :key="index" :clickable="true" @click="clickCell(item)">
                        <div class="radioLeft">
                            <img :src="item.imgUrl" alt="未加载成功" class="img">
                            <span class="text">{{item.text}}</span>
                        </div>
                        <van-radio slot="right-icon" :disabled='totalMoeny < 0 || radioShow' :name="item.value" />
                    </van-cell>
                </van-cell-group>
            </van-radio-group>
        </div>
        <div class="bgFFFFFF areaTitle" v-if="showBankList && (isApproveData.openStatus === 3)">
            <span class="col666 f28">快捷支付</span>
            <span class="colFF7A45 f26 pointer" @click="binkCard">点击绑定新卡</span>
        </div>
        <div class="content" v-if="showBankList && (isApproveData.openStatus === 3)">
            <van-radio-group v-model="radio" icon-size="20px" checked-color="#FF7A45">
                <van-cell-group>
                    <van-cell v-for="(item, index) in bankCardsList" :key="index" :clickable="true" @click="clickCell(item)">
                        <div class="radioLeft">
                            <img :src="bankImgUrl" class="img">
                            <span class="text">{{item.text}}</span>
                            <span class="tip col999">({{item.tip}})</span>
                        </div>
                        <van-radio slot="right-icon" :disabled='totalMoeny < 0 || radioShow' :name="item.value" />
                    </van-cell>
                </van-cell-group>
            </van-radio-group>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'topUps',
    props: {
        checkedValue: {
            type: Object,
            default: () => {
                return {
                    payMethod: 0,
                    rate: 0
                }
            }
        },
        isApproveData: {
            type: Object,
            default: () => {
                return {
                    authenticationStatus: 3
                }
            }
        },
        showBalance: {
            type: Boolean,
            default: false
        },
        showBankList: {
            type: Boolean,
            default: true
        },
        inRansom: {
            type: Boolean,
            default: false
        },
        balance: {
            type: Number,
            default: 0
        },
        activityWalletBalance: {
            type: Number,
            default: 0
        },
        bankCardsList: {
            type: Array,
            default: () => []
        },
        showType: {
            type: Boolean,
            default: false
        },
        // 支付金额
        finalTotalAmount: {
            type: Number,
            default: 0
        },
        // 活动钱包支付隐藏
        isActivityShow: {
            type: Boolean,
            default: false
        },
        // 运费, 预售订单单选
        payShow: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            userInfo: '',
            result: [], // 活动余额和钱包余额
            totalMoeny: 0, // 最终金额
            payBalance: 0, // 钱包余额
            payActivity: 0, // 活动预充余额
            radioShow: false, // 第三方禁用
            balanceShow: false, // 钱包checked显示
            activityShow: false, // 活动预充checed显示
            paymentList: [
                {
                    text: '微信支付',
                    value: {
                        payMethod: 40,
                        rate: 0.3
                    },
                    imgUrl: require('../../assets/img/b2b/weChart@2x.png')
                },
                {
                    text: '支付宝支付',
                    value: {
                        payMethod: 50,
                        rate: 0.3
                    },
                    imgUrl: require('../../assets/img/b2b/alipay@2x.png')
                }
                // ,
                // {
                //     text: '网银支付',
                //     value: {
                //         payMethod: 30,
                //         rate: 0
                //     },
                //     imgUrl: require('../../assets/img/b2b/onlineBanking@2x.png')
                // }
            ],
            bankImgUrl: require('../../assets/img/b2b/bank.png')
        }
    },
    watch: {
        result: {
            handler (val) {
                this.$emit('update:payPurse', val)
                if (!val.length) {
                    this.payActivity = 0
                    this.payBalance = 0
                    this.totalMoeny = 0
                    this.activityShow = false
                    this.balanceShow = false
                    this.radioShow = false
                    return
                }
                let price = val.reduce((pre, cur) => {
                    return pre + cur.price
                }, 0)
                this.totalMoeny = (this.finalTotalAmount - price).toFixed(2)
                this.radioShow = false
                if (this.totalMoeny <= 0) {
                    this.radio = {}
                    this.radioShow = true
                }
                if (val.length === 1) {
                    if (val[0].name === 'balance') {
                        this.payActivity = 0
                        this.payBalance = this.totalMoeny >= 0 ? val[0].price : (this.finalTotalAmount - this.payActivity).toFixed(2)
                        this.balanceShow = this.finalTotalAmount === parseFloat(this.payBalance)
                        this.activityShow = false
                        this.payActivity = 0
                    } else if (val[0].name === 'activity') {
                        this.payBalance = 0
                        this.payActivity = this.totalMoeny >= 0 ? val[0].price : (this.finalTotalAmount - this.payBalance).toFixed(2)
                        this.activityShow = this.finalTotalAmount === parseFloat(this.payActivity)
                        this.balanceShow = false
                        this.payBalance = 0
                    }
                } else {
                    if (val[1].name === 'balance') {
                        this.payBalance = this.totalMoeny >= 0 ? val[1].price : (this.finalTotalAmount - this.payActivity).toFixed(2)
                    } else if (val[1].name === 'activity') {
                        this.payActivity = this.totalMoeny >= 0 ? val[1].price : (this.finalTotalAmount - this.payBalance).toFixed(2)
                    }
                }
                // 用来处理支付的入参
                val.forEach(item => {
                    if (item.payMethod === 10) {
                        item.orderAmount = this.payBalance
                    } else {
                        item.orderAmount = this.payActivity
                    }
                })
                this.$emit('update:payPurse', val)
            },
            // 这里是关键，代表递归监听 demo 的变化
            deep: true
        }
    },
    computed: {
        ...mapState({
            getRealut: state => state.b2b.walletState
        }),
        walletBalance: function () {
            return {
                text: '钱包余额',
                tip: this.balance,
                value: {
                    payMethod: 10,
                    price: this.balance,
                    name: 'balance',
                    rate: 0
                },
                imgUrl: require('../../assets/img/b2b/qb.png')
            }
        },
        activityBalance: function () {
            return {
                text: '活动预充余额',
                tip: this.activityWalletBalance,
                value: {
                    payMethod: 11,
                    price: this.activityWalletBalance,
                    name: 'activity',
                    rate: 0
                },
                imgUrl: require('../../assets/img/b2b/a3.png')
            }
        },
        radio: {
            get: function () {
                return this.checkedValue
            },
            set: function (newValue) {
                this.$emit('update:checkedValue', newValue)
            }
        }
    },
    methods: {
        // 添加cell点击响应事件
        clickCell (item) {
            if (this.totalMoeny < 0 || this.radioShow) {
                return false
            }
            this.radio = item.value
        },
        toggle (val) {
            if (val === 'activity' && (this.activityBalance.tip <= 0 || this.inRansom || this.balanceShow)) {
                return false
            } else if (val === 'wallet' && ((this.isApproveData.openStatus === 3 && this.walletBalance.tip <= 0) || this.activityShow)) {
                return false
            }
            if (val === 'activity') {
                this.$refs.checkboxes.toggle()
            } else if (val === 'wallet') {
                this.$refs.checkboxesArr.toggle()
            }
        },
        binkCard () {
            this.$emit('binkCard')
        }
    },
    mounted () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    }
}
</script>
<style lang="scss" scoped>
.applyRadioPage {
    .content {
        font-size: 32px;
        color: #000000;
        padding-left: 32px;
        background: #ffffff;
        &.mbot48 {
            margin-bottom: 48px;
        }
    }
    .areaTitle {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 24px 32px;
        border-bottom: 1px solid #ededf0;
    }
    .radioLeft {
        display: flex;
        align-items: center;
        .img {
            position: relative;
            width: 80px;
            height: 80px;
            margin-right: 24px;
            border-radius: 50%;
        }
        .name {
            p {
                display: flex;
                align-items: center;
                font-size: 28px;
                .tip {
                    margin-right: 24px;
                    white-space: nowrap;
                    overflow: hidden;
                }
                .price {
                    color: #ff7a45;
                }
            }
        }
        .text {
            display: inline-block;
            /* line-height: 80px; */
            font-size: 32px;
            font-weight: 400;
            margin-right: 16px;
            color: #000000;
            white-space: nowrap;
            overflow: hidden;
        }
    }
    .burse {
        text-align: center;
        padding: 0 32px;
        .buttom {
            height: 96px;
            line-height: 96px;
            border-radius: 96px;
            border: 2px solid #ff7a45;
            margin-bottom: 40px;
        }
    }
    /deep/ .van-cell__value {
        line-height: initial;
        height: auto;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: initial;
        white-space: normal;
        word-break: break-all;
        color: #676767;
    }
    /deep/ .van-radio,
    /deep/ .van-checkbox {
        margin: 0 32px;
    }
    /deep/ .van-radio__icon,
    /deep/ .van_checkbox_icon {
        width: 40px;
        height: 40px;
        line-height: 40px;
    }
    /deep/ .van-icon {
        width: 40px;
        height: 40px;
        line-height: 40px;
        border: 1px solid #d1d1d6;
    }
}
</style>
